import { Box, Flex } from 'components/elements'
import { ShimmerCss } from './ListShimmer'
import React from 'react'

export const ReportShimmer = () => {
  return (
    <>
      <Flex direction={'column'} css={{ p: '$space$10', pb: '$space$20' }}>
        <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$10' }}></Box>
        <Box css={{ ...ShimmerCss, ...SubTitleCss }}></Box>
        <Box
          css={{
            ...ShimmerCss,
            ...DescriptionCss,
            mb: '$space$2',
            mt: '$space$2',
          }}
        ></Box>
        <Box css={{ ...ShimmerCss, ...TitleCss }}></Box>
      </Flex>

      <Box css={{ height: 1, mb: '$space$20', background: '$border' }}></Box>

      {/* <Box css={{ p: '$space$15', background: '$bgBody', borderRadius: '$md' }}>
        <Flex align={'center'}>
          <Box css={{ ...ShimmerCss, ...CircleCss }}></Box>
          <Flex direction={'column'}>
            <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2' }}></Box>
            <Box css={{ ...ShimmerCss, ...SubTitleCss }}></Box>
          </Flex>
          <Box css={{ ...ShimmerCss, ...IconCss }}></Box>
        </Flex>
      </Box> */}

      {[...Array(4)].map((_, index) => (
        <React.Fragment key={index}>
          <Box
            css={{ p: '$space$15', my: '$space$15', background: '$gray300' }}
          >
            <Flex align={'center'}>
              <Box css={{ ...ShimmerCss, ...IconSmallCss }}></Box>
              <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2' }}></Box>
            </Flex>
          </Box>
          <Box css={{ '& > div:nth-child(even)': { background: '$bgBody' } }}>
            <Flex align={'center'} css={{ p: '$space$10' }}>
              <Box css={{ ...ShimmerCss, ...TitleCss, mr: 200 }}></Box>
              <Box css={{ ...ShimmerCss, ...SubTitleCss }}></Box>
            </Flex>
            <Flex align={'center'} css={{ p: '$space$10' }}>
              <Box css={{ ...ShimmerCss, ...TitleCss, mr: 200 }}></Box>
              <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
              <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
            </Flex>
            <Flex align={'center'} css={{ p: '$space$10' }}>
              <Box css={{ ...ShimmerCss, ...TitleCss, mr: 200 }}></Box>
              <Box css={{ ...ShimmerCss, ...ButtonCss, mr: '$space$5' }}></Box>
              <Box css={{ ...ShimmerCss, ...ButtonCss, mr: '$space$5' }}></Box>
            </Flex>
          </Box>
        </React.Fragment>
      ))}
    </>
  )
}
const IconSmallCss = {
  width: 24,
  height: 24,
  mr: '$space$15',
}
// const IconCss = {
//   width: 40,
//   height: 40,
//   ml: '$space$15',
// }
// const CircleCss = {
//   width: 40,
//   height: 40,
//   mr: '$space$15',
//   borderRadius: '$rounded',
// }
const TitleCss = {
  width: 120,
  height: 20,
}
const DescriptionCss = {
  width: 180,
  height: 20,
}
const SubTitleCss = {
  width: 250,
  height: 20,
}
const Tags1Css = {
  width: 90,
  height: 22,
  borderRadius: '$size$10',
}

const ButtonCss = {
  width: 22,
  height: 22,
  borderRadius: '$size$4',
}
